<template>
  <a class="mk-button">
    {{ childItem.propsValue.text }}
  </a>
</template>

<script>
export default {
  name: "MkButton",
  props: {
    value: {
      type: String,
      default: "按钮",
    },
   childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      text: '按钮',
      beforeClick: {
        type: 0,  // 0 直接访问使用， 1 填写表单后有效
        form: "",  // 表单ID，按钮点击需填写表单
        formtime: '无' // 表单有效期  无 一天 七天 永久  
      },
      afterClick: {
        type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
        url: "",
        contentType: "data", // data 资料， article 文章， video 视频
        contentId: "",
      },
    };
  }
};
</script>

<style scoped lang="scss">
.mk-button {
  .user-select {
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
  }
}
</style>
